import React from "react";
import Navbar from "../../Navbar/Navbar";
import linkedin from "../../../img/in.svg";
import mail from "../../../img/mail.svg";
import phone from "../../../img/cellphone.svg";
import github from "../../../img/github.svg";
import insta from "../../../img/insta.svg";
import face from "../../../img/face.svg";
const Contact = () => {
	return (
		<div>
			<Navbar />
			<div className="contact-container">
				<div className="contact_me">Contact Me</div>
				<div className="social_media">
					<a href="https://www.linkedin.com/in/jose-vazcortez" target="_blank">
						<img src={linkedin} alt="Linkedin" />
					</a>
					<a
						href="mailto:jose.vazcortez@gmail.com"
						target="_blank"
						rel="noopener noreferrer">
						<img src={mail} alt="Email" />
					</a>
					<a href="tel:+3329330193" target="_blank" rel="noopener noreferrer">
						<img src={phone} alt="Phone" />
					</a>
					<a
						href="https://github.com/JoseCortez1"
						target="_blank"
						rel="noopener noreferrer">
						<img src={github} alt="github" />
					</a>
					<a href="#" target="_blank" rel="noopener noreferrer">
						<img src={insta} alt="Instagram" />
					</a>
					<a href="#" target="_blank" rel="noopener noreferrer">
						<img src={face} alt="Facebook" />
					</a>
				</div>
				<div className="buttons">
					<div className="container_data">
						<p>Cellphone:</p>
						<a href="tel:+3329330193">3329330193</a>
					</div>
					<div className="container_data">
						<p>email:</p>
						<a href="mailto:jose.vazcortez@gmail.com">
							jose.vazcortez@gmail.com
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Contact;
